import { OfferResumeResponse } from './offer-resume.response';
export const createMockOfferResumeResponse = (customValues) => {
    const response = new OfferResumeResponse();
    response.id = customValues?.id ?? 1;
    response.position = customValues?.position ?? 'position';
    response.slug = customValues?.slug ?? 'slug';
    response.status = customValues?.status ?? 'ACTIVE';
    response.salaryFrom = customValues?.salaryFrom ?? 35000;
    response.salaryTo = customValues?.salaryTo ?? 45000;
    response.bonus = customValues?.bonus ?? 5000;
    response.remotePercentage = customValues?.remotePercentage ?? 50;
    response.equityInf = customValues?.equityInf ?? 3;
    response.equitySup = customValues?.equitySup ?? 5;
    response.currency = customValues?.currency ?? '€';
    response.noStack = customValues?.noStack ?? true;
    response.offerLanguages = customValues?.offerLanguages ?? ['ES', 'EN'];
    response.highlights = customValues?.highlights ?? ['highlight 1', 'highlight 2'];
    response.locations = customValues?.locations ?? ['location 1', 'location 2'];
    response.updatedAt = customValues?.updatedAt ?? new Date('2021-01-01T00:00:00Z');
    response.migratedToMarkdown = customValues?.migratedToMarkdown ?? false;
    response.isFreelance = customValues?.isFreelance ?? false;
    response.feeRateFrom = customValues?.feeRateFrom ?? 10;
    response.feeRateTo = customValues?.feeRateTo ?? 20;
    response.company = {
        name: customValues?.company?.name ?? 'company',
        web: customValues?.company?.web ?? 'company.com',
        photo: customValues?.company?.photo ?? {
            url: 'company photo',
            alt: 'company photo alt',
            filename: 'photo.png',
            id: 1,
            title: 'company photo title'
        },
        logo: customValues?.company?.logo ?? { url: 'company logo', alt: 'company logo alt', filename: 'logo.png', id: 1, title: 'company logo title' },
        logoDark: customValues?.company?.logoDark ?? {
            url: 'company logo dark',
            alt: 'company logo dark alt',
            filename: 'logo-dark.png',
            id: 2,
            title: 'company logo dark title'
        },
        primaryColor: customValues?.company?.primaryColor ?? 'primary color',
        secondaryColor: customValues?.company?.secondaryColor ?? 'secondary color'
    };
    return response;
};
//# sourceMappingURL=offer-resume.response.mock.js.map